module.exports = __webpack_public_path__ + "img/equipment-02@2x.bb4d6e56.png";